<h1 mat-dialog-title>Ausstallliste abschließen</h1>
<div mat-dialog-content>
    <mat-form-field style="width: 100%">
        <mat-label>Abgangsdatum</mat-label>
        <input [formControl]="datumCtrl" [matDatepicker]="picker" [readonly]="true" matInput />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
    <mat-form-field style="width: 100%">
        <mat-label>Bezeichnung / KFZ-Kennzeichen Transportfahrzeug</mat-label>
        <input [formControl]="kfzCtrl" matInput type="text" />
        <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
    <div *ngIf="!istDerselbeKunde()" style="margin-top: 12px">
        <p style="font-size: 0.9em">
            Sollen die Tiere mit dem Datum
            {{ datumCtrl.value | date: "dd.MM.yyyy" }} in HIT als Abgang gemeldet werden? Die Abgänge werden erst nach
            diesem Datum gemeldet.
        </p>
        <mat-radio-group aria-label="Abgang an HIT melden ja oder nein" [formControl]="hitMeldenCtrl">
            <mat-radio-button [value]="0">nein</mat-radio-button>
            <mat-radio-button [value]="1">ja</mat-radio-button>
        </mat-radio-group>
        <div style="margin-top: 12px">
            <mat-checkbox [formControl]="gewichteImportierenCtrl">
                Empfänger darf die Gewichte importieren
            </mat-checkbox>
        </div>
    </div>
    <div *ngIf="localStorageService.isCurrentUserViehhaendler()" style="margin-top: 12px">
        <kiene-autocomplete
            [apiUrl]="apiBaseUrl + 'exportland/'"
            (elementSelected)="exportlandSelected($event)"
            [displayFields]="['kuerzel', 'land']"
            [kieneObject]="exportland"
            placeholder="Exportland auswählen (optional)"
            separator=" - "
        ></kiene-autocomplete>
    </div>
    <div class="info-box" style="font-size: 0.8em">
        Beim Abschließen der Ausstallliste wird der Empfänger
        {{ abgangsliste.kunde_einstallen }} informiert, dass die Tiere zum eingetragenem Datum transportiert werden
        sollen.
    </div>
</div>
<div mat-dialog-actions>
    <span class="spacer"></span>
    <button mat-button (click)="close()">Abbrechen</button>
    <button mat-flat-button color="accent" (click)="save()" [disabled]="isSaving"> Abschlie&szlig;en </button>
</div>
